export const AUTH_STEP = {
  DEFAULT: 'default', // login and register modal,
  FORGOT_PASSWORD: 'forgotPassword', // forgot password modal
  EMAIL_VERIFICATION: 'emailVerification', // email verification modal
  PHONE_VERIFICATION: 'phoneVerification', // phone verification modal
  TWO_FACTOR_VERIFICATION: 'twoFactorVerification', // first-time code verification modal
  TWO_FACTOR_AUTH: 'twoFactorAuth', // two factor auth modal
};

export const AUTH_STEPS = [
  AUTH_STEP.DEFAULT,
  AUTH_STEP.FORGOT_PASSWORD,
  AUTH_STEP.EMAIL_VERIFICATION,
  AUTH_STEP.PHONE_VERIFICATION,
  AUTH_STEP.TWO_FACTOR_VERIFICATION,
  AUTH_STEP.TWO_FACTOR_AUTH,
] as const;

export type TAuthSteps = (typeof AUTH_STEPS)[number];
